"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var core_1 = require("@material-ui/core");

var date_fns_1 = require("date-fns");

var Menu_1 = __importDefault(require("./components/Menu"));

var theme = core_1.createMuiTheme({
  typography: {
    useNextVariants: true
  }
});
exports.MARKERS = {
  FIRST_MONTH: Symbol("firstMonth"),
  SECOND_MONTH: Symbol("secondMonth")
};

var styles = function styles(theme) {
  return core_1.createStyles({
    header: {
      padding: "20px 70px"
    },
    headerItem: {
      flex: 1
    },
    divider: {
      borderLeft: "1px solid " + theme.palette.action.hover,
      marginBottom: 20
    }
  });
};

var getRanges = function getRanges(date) {
  return [{
    label: "Today",
    startDate: date,
    endDate: date
  }, {
    label: "Yesterday",
    startDate: date_fns_1.addDays(date, -1),
    endDate: date_fns_1.addDays(date, -1)
  }, {
    label: "This Week",
    startDate: date_fns_1.startOfWeek(date),
    endDate: date_fns_1.endOfWeek(date)
  }, {
    label: "Last Week",
    startDate: date_fns_1.startOfWeek(date_fns_1.addWeeks(date, -1)),
    endDate: date_fns_1.endOfWeek(date_fns_1.addWeeks(date, -1))
  }, {
    label: "This Month",
    startDate: date_fns_1.startOfMonth(date),
    endDate: date_fns_1.endOfMonth(date)
  }, {
    label: "Last Month",
    startDate: date_fns_1.startOfMonth(date_fns_1.addMonths(date, -1)),
    endDate: date_fns_1.endOfMonth(date_fns_1.addMonths(date, -1))
  }];
};

var DateRangePickerImpl = function DateRangePickerImpl(props) {
  // console.log("rendering DateRangePicker");
  var _a = React.useState(__assign({}, props.dateRange)),
      dateRange = _a[0],
      setDateRange = _a[1];

  var _b = React.useState(),
      hoverDay = _b[0],
      setHoverDay = _b[1];

  var _c = React.useState(props.dateRange && props.dateRange.startDate || new Date()),
      firstMonth = _c[0],
      setFirstMonth = _c[1];

  var _d = React.useState(props.dateRange && props.dateRange.endDate || date_fns_1.addMonths(firstMonth, 1)),
      secondMonth = _d[0],
      setSecondMonth = _d[1];

  var startDate = dateRange.startDate,
      endDate = dateRange.endDate;
  var classes = props.classes,
      open = props.open,
      onChange = props.onChange;
  var ranges = getRanges(new Date()); // handlers

  var setFirstMonthValidated = function setFirstMonthValidated(date) {
    if (date_fns_1.isBefore(date, secondMonth)) {
      setFirstMonth(date);
    }
  };

  var setSecondMonthValidated = function setSecondMonthValidated(date) {
    if (date_fns_1.isAfter(date, firstMonth)) {
      setSecondMonth(date);
    }
  };

  var setDateRangeValidated = function setDateRangeValidated(range) {
    if (range.startDate && range.endDate) {
      setDateRange(range);
      setFirstMonth(range.startDate);
      setSecondMonth(date_fns_1.isSameMonth(range.startDate, range.endDate) ? date_fns_1.addMonths(range.startDate, 1) : range.endDate);
    }
  };

  var onDayClick = function onDayClick(day) {
    if (startDate && !endDate && !date_fns_1.isBefore(day, startDate)) {
      var newRange = {
        startDate: startDate,
        endDate: day
      };
      onChange(newRange);
      setDateRange(newRange);
    } else {
      setDateRange({
        startDate: day,
        endDate: undefined
      });
    }

    setHoverDay(day);
  };

  var onMonthNavigate = function onMonthNavigate(marker, action) {
    if (marker == exports.MARKERS.FIRST_MONTH) {
      var firstNew = date_fns_1.addMonths(firstMonth, action);
      if (date_fns_1.isBefore(firstNew, secondMonth)) setFirstMonth(firstNew);
    } else {
      var secondNew = date_fns_1.addMonths(secondMonth, action);
      if (date_fns_1.isBefore(firstMonth, secondNew)) setSecondMonth(secondNew);
    }
  };

  var onDayHover = function onDayHover(date) {
    if (startDate && !endDate) {
      if (!hoverDay || !date_fns_1.isSameDay(date, hoverDay)) {
        setHoverDay(date);
      }
    }
  }; // helpers


  var inHoverRange = function inHoverRange(day) {
    return startDate && !endDate && hoverDay && date_fns_1.isAfter(hoverDay, startDate) && date_fns_1.isWithinRange(day, startDate, hoverDay);
  };

  var helpers = {
    inHoverRange: inHoverRange
  };
  var handlers = {
    onDayClick: onDayClick,
    onDayHover: onDayHover,
    onMonthNavigate: onMonthNavigate
  };
  return React.createElement(core_1.MuiThemeProvider, {
    theme: theme
  }, React.createElement(core_1.CssBaseline, null), open && React.createElement(Menu_1.default, {
    dateRange: dateRange,
    ranges: ranges,
    firstMonth: firstMonth,
    secondMonth: secondMonth,
    setFirstMonth: setFirstMonthValidated,
    setSecondMonth: setSecondMonthValidated,
    setDateRange: setDateRangeValidated,
    helpers: helpers,
    handlers: handlers
  })); //return (<Typography>Hello blahblas {props.title}</Typography>);
};

exports.DateRangePicker = core_1.withStyles(styles)(DateRangePickerImpl);